import { render } from "./DetailsProducts.vue?vue&type=template&id=73bf93ca&scoped=true"
import script from "./DetailsProducts.vue?vue&type=script&lang=js"
export * from "./DetailsProducts.vue?vue&type=script&lang=js"

import "./DetailsProducts.vue?vue&type=style&index=0&id=73bf93ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bf93ca"]])

export default __exports__